<script>
export default {
  translate25Context: "vprojector",
  components: {},
  data: () => {
    return {
      showItems: false,
    };
  },
  props: ["component", "handler"],
  methods: {
    itemsLength: function () {
      return Object.keys(this.component.items).length;
    },
  },
};
</script>

<template>
  <div>
    <component
      v-if="itemsLength() == 1"
      v-bind:is="Object.values(component.items)[0].data.type"
      :component="Object.values(component.items)[0]"
      :handler="handler"
    ></component>
    <div
      v-if="itemsLength() > 1"
      class="vprojector-card category"
      @click="showItems = !showItems"
    >
      <div class="icon">
        <f-icon :icon="component.data.icon" figma></f-icon>
      </div>
      <div class="title">{{ $vt(component.data.title) }}</div>
      <div
        class="tag"
        :class="{ highlight: component.data.tag_highlight }"
        v-if="component.data.tag"
      >
        {{ $vt(component.data.tag) }}
      </div>
      <div class="list">
        <div
          class="list-item"
          v-for="(list_item, index) in component.data.list"
          :key="index"
        >
          <div class="list-item-icon"><f-icon icon="fa6-check"></f-icon></div>
          <div>{{ $vt(list_item.text) }}</div>
        </div>
      </div>
      <div class="cost">{{ $vt(component.data.cost) }}</div>
      <f-button class="view" type="highlight"
        >{{ $vt("Start") }} <f-icon icon="fa6-arrow-right"></f-icon
      ></f-button>
    </div>
    <transition name="vprojector-items-fade">
      <div
        v-if="showItems"
        class="vprojector-items"
        @click="
          showItems = $event.target.classList.contains('vprojector-items')
            ? false
            : showItems
        "
      >
        <div class="goBack">
          <f-button type="icon tertiary overlay" @click.stop="showItems = false"
            ><f-icon icon="fa6-arrow-left"></f-icon
          ></f-button>
          {{ $vt("Start a new project") }}
        </div>
        <div class="category">{{ $vt(component.data.title) }}</div>
        <div class="items">
          <component
            v-for="(item, nid) in $options.filters.angularFilter(
              component.items,
              ['weight'],
              'orderObjectBy'
            )"
            :key="nid"
            v-bind:is="item.data.type"
            :component="item"
            :handler="handler"
          >
          </component>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
.vprojector-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 24px 32px;
  width: 240px;
  height: 100%;
  min-height: 450px;
  background: var(--black);
  box-shadow: 0px 24px 32px -8px rgba(22, 21, 21, 0.5);
  border-radius: 12px;
  cursor: pointer;

  &:hover {
    // background: var(--black-a75);
    box-shadow: 0px 24px 48px -8px rgba(22, 22, 21, 0.33);
  }

  &.pending {
    // background: var(--black-a75);
    box-shadow: 0px 24px 48px -8px rgba(22, 22, 21, 0.33);
  }

  .icon {
    width: 96px;
    height: 96px;
  }

  .title {
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 32px;
    line-height: 100%;
    text-align: center;
    color: var(--white-a75);
	padding: 8px;
  }

  &:hover .title,
  &.pending .title {
    color: var(--white-a75);
  }

  .tag {
    margin-top: 8px;
    background: transparent;
    border-radius: 16px;
    padding: 4px 12px;
    text-align: center;
    font-family: Lato;
    font-style: normal;
    font-weight: 900;
    font-size: 12px;
    line-height: 125%;
    color: var(--black);

    &.highlight {
      background: var(--primary);
      color: var(--white-a75);
    }
  }

  .list {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .list-item {
      display: flex;
      font-family: Lato;
      font-style: normal;
      font-weight: 300;
      font-size: 12px;
      line-height: 125%;
      color: var(--white-a75);

      .list-item-icon {
        margin-right: 10px;
        color: var(--primary);
      }
    }
  }

  .cost {
    margin-top: auto;
    padding-top: 16px;
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 125%;
    color: var(--white-a75);
  }

  .view {
    margin-top: 17px;
  }
}

.vprojector-items {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #2a2a2ab5;
  backdrop-filter: blur(20px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 1;

  > .goBack {
    display: flex;
    align-items: center;
    gap: 4px;
    font-family: Lato;
    font-weight: normal;
    font-size: 24px;
    line-height: 100%;
    color: var(--white-a75);
    cursor: pointer;

    .f-button .f-icon {
      color: var(--white-a75);
    }
  }

  > .category {
    margin-top: 13px;
    font-family: Lato;
    font-weight: normal;
    font-size: 48px;
    line-height: 58px;
    color: var(--white-a90);
  }

  > .items {
    margin-top: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 32px;
  }
}

.vprojector-items-fade-enter-active {
  // transition: all 0.25s ease;
}
.vprojector-items-fade-enter,
.vprojector-items-fade-leave-to {
  opacity: 0;
}
</style>